module.exports = __webpack_public_path__ + "bd.7d936d627408e7d76fbf.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/bd.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/bd.svg
// module chunks = styles